import React, { Fragment } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Button from "./button";
import Scrollbars from "react-custom-scrollbars";
import Chip from "./chip";
import StatusTooltip from "./status_tooltip";
import QuantityEditor from "./quantity_editor";
import IconButton from "./icon_button";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  flex: 1 1 0px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 5px 10px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderLabel = styled.span`
  color: #494b50;
  font-size: 12px;
  font-weight: 400;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const SubAccessoriesBOMWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SelectOptionTypeTitle = styled.span`
  color: #2f3136;
  font-size: 16px;
  font-weight: 700;
`;

const OptionTypesWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  min-height: 35px;
  max-height: 35px;
  height: 35px;
`;

const ChipWrapper = styled.div`
  margin-right: 5px;
`;

const SelectedOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background-color: white;
  border: 1px solid #E7E6E6;
  border-radius: 4px;
  box-sizing: content-box;
  min-height: 40px;
  margin-bottom: 5px;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    flex-direction: column;
    align-items: unset;
  }
`;

const SelectedOptionDescription = styled.span`
  font-weight: 400;
  font-size: 14px;
  border-left: 2px solid rgba(98, 100, 105, 0.2);
  margin-left: 10px;
  padding-left: 10px;
  flex: 1 1 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    border-left: unset;
    margin-left: 0px;
    margin-top: 10px;
    padding-left: 0px;
    overflow: visible;
    text-overflow: unset;
    white-space: unset;
  }
`;

const ActionsWrapper = styled.div`
  display: flex;
  margin-left: 10px;
  align-items: center;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    margin-left: 0px;
    margin-top: 10px;
    justify-content: space-between;
  }
`;

const LinkWrapper = styled.div`
  display: inline-flex;
  font-weight: 700;
  margin-right: 10px;
`;

const StatusAndTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const EditAndDeleteWrapper = styled.div`
  display: flex;
`;

const Content = styled.div``;

const OptionsContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    flex-direction: column;
  }
`;

const OptionWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(50% - 10px);
  padding: 24px 24px 24px 10px;
  margin-bottom: 15px;
  margin-right: 10px;

  background: #FFFFFF;
  border: 1px solid rgba(160, 164, 168, 0.4);
  border-radius: 4px;

  ${props => props.disabled && 'opacity 0.75; pointer-events: none;'}

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    flex: 1 1 0px;
    margin-right: 0px;
  }
`;

const OptionContent = styled.div`
  display: flex;
`;

const OptionImage = styled.img`
  width: 80px;
  height: 80px;
  margin-right: 10px;
  @media (max-width: 400px) {
    width: 50px;
    height: 50px;
  }
`;

const DescriptionWrapper = styled.div`
  display: flex;
  margin-top: 5px;
`;

const OptionDescription = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #626469;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
`;

const OptionRow = styled.div`
  display: flex;
  margin-left: 5px;
  justify-content: space-between;
  align-items: center;
`;

const OptionLinkWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
`;


const CategoryDescriptionAndActionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex: 1 1 0px;
`;

const OptionCol = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
`;

const ActionButtonWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  justify-content: flex-end;
`;

class SubAccessoriesManager extends React.Component {
  static propTypes = {
    deviceIdentification: PropTypes.object,
    accessoryIdentification: PropTypes.object,
    option: PropTypes.object,
    renderProductLink: PropTypes.func,
    subAccessories: PropTypes.object,
    getLabel: PropTypes.func,
    getAndReplaceLabel: PropTypes.func,
    mobileBreakpoint: PropTypes.number,
    primaryColor: PropTypes.string,
    primaryTextColor: PropTypes.string,
    onAddSubAccessories: PropTypes.func,
    onDecreaseSubAccessories: PropTypes.func,
    onRemoveSubAccessories: PropTypes.func,
    raiseNotificationEvent: PropTypes.func,
    retrieveOptions: PropTypes.func,
    isSaving: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      subAccessoriesExpanded: false,
      selectedOptionTypes: {},
    };
    this._isMounted = true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  // Extract the distinct sub accessory types. We get rid of the duplicate types keys.
  extractSubAccessoryTypes = () => {
    const subAccTypes = {};

    const subAccessoryCategories = Object.values(this.props.subAccessories);

    subAccessoryCategories.forEach((subAccCategory) => {
      (subAccCategory.optionTypes || []).forEach((subAccType) => {
        subAccTypes[subAccType.key] = subAccType;
      });
    });

    return Object.values(subAccTypes);
  };

  renderToggleButton = (accessoryIdentification, numberOfSubAccessories, onClick) => {
    let buttonProps;

    if (this.state.isOpen) {
      buttonProps = {
        id: `${accessoryIdentification.identificationKey}-subaccessories-close`,
        label: this.props.getLabel("app.action.close"),
        outline: true,
        color: "#626469",
        textColor: "#626469",
        onClick,
      };
    } else {
      buttonProps = {
        id: `${accessoryIdentification.identificationKey}-subaccessories-view-all`,
        label: this.props.getLabel(
          numberOfSubAccessories === 0
            ? "app.action.view"
            : "app.action.view_all"
        ),
        color: "#626469",
        textColor: "white",
        onClick,
      };
    }

    return <Button {...buttonProps}></Button>;
  };

  renderSubAccessoriesBOM = () => {
    const subAccessoriesWithQuantity = Object.values(
      this.props.subAccessories
    ).filter((subAcc) => subAcc.quantity > 0);

    return (
      <SubAccessoriesBOMWrapper>
        {subAccessoriesWithQuantity.map((subAcc, idx) => {
          const description = subAcc.getOptionDescription();
          return (
            <SelectedOptionWrapper mobileBreakpoint={this.props.mobileBreakpoint} key={idx}>
            <StatusAndTitleWrapper>
              {subAcc.status && subAcc.status !== 'normal' && <StatusTooltip status={subAcc.status} getLabel={this.props.getLabel} cursor={'help'}></StatusTooltip>}
              <LinkWrapper>
                {this.props.renderProductLink(subAcc.id)}
              </LinkWrapper>
            </StatusAndTitleWrapper>
            <SelectedOptionDescription mobileBreakpoint={this.props.mobileBreakpoint} title={description}>{description}</SelectedOptionDescription>
            <ActionsWrapper mobileBreakpoint={this.props.mobileBreakpoint}>
              {this.renderQuantity(subAcc)}
              {this.renderActionButtons(subAcc)}
            </ActionsWrapper>
          </SelectedOptionWrapper>
          );
        })}
      </SubAccessoriesBOMWrapper>
    );
  };

  renderActionButton = (subAcc, addDisabled) => {
    return (
      <ActionButtonWrapper>
        {subAcc.quantity > 0 && <QuantityEditor id={`${this.props.accessoryIdentification.identificationKey}-${subAcc.subAccessoryIdentification.identificationKey}-subaccessories`} primaryColor={this.props.primaryColor} primaryTextColor={this.props.primaryTextColor} isSaving={this.props.isSaving} quantity={subAcc.quantity} canIncrease={subAcc.canIncrease}
            onIncrease={() => {
              this.props.onAddSubAccessories(this.props.deviceIdentification, this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(() => {
                this.props.raiseNotificationEvent('added', subAcc, 1);
                this.props.retrieveOptions();
              });
             }}
            canDecrease={subAcc.canDecrease || (subAcc.quantity === 1 && subAcc.canRemove)}
            onDecrease={() => {
              this.props.onDecreaseSubAccessories(this.props.deviceIdentification, this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(() => {
                this.props.raiseNotificationEvent('removed', subAcc, 1);
                this.props.retrieveOptions();
              });
        }}></QuantityEditor>}
        {(subAcc.canRemove && subAcc.quantity > 0) && <IconButton id={`${this.props.accessoryIdentification.identificationKey}-${subAcc.subAccessoryIdentification.identificationKey}-subaccessories-remove`} icon="remove" size={40} padding={7} color={'#626469'} disabled={this.props.isSaving} onClick={() => {
          this.props.onRemoveSubAccessories(this.props.deviceIdentification, this.props.accessoryIdentification, subAcc.subAccessoryIdentification).then(() => {
            this.props.raiseNotificationEvent('removed', subAcc, 1);
            this.props.retrieveOptions();
          });
         }}></IconButton>}
        {subAcc.quantity === 0 && <Button id={`${this.props.accessoryIdentification.identificationKey}-${subAcc.subAccessoryIdentification.identificationKey}-subaccessories-add`} label={this.props.getLabel('app.action.add')} icon={'plus-large'} disabled={addDisabled} title={subAcc.disabledMessage} onClick={() => {
          if (!addDisabled) {
            this.props.onAddSubAccessories(this.props.deviceIdentification, this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(() => {
              this.props.raiseNotificationEvent('added', subAcc, 1);
              this.props.retrieveOptions();
            });
          }
          }}>
        </Button>}
      </ActionButtonWrapper>
    );
  }

  renderSubAccessoryTypes = (subAccessoryTypes) => {
    return (
      <>
        <SelectOptionTypeTitle>
          {this.props.getLabel("options_screen.select_type")}
        </SelectOptionTypeTitle>
        <OptionTypesWrapper
          mobileBreakpoint={this.props.mobileBreakpoint}
        >
          <Scrollbars>
            <div style={{ display: "flex" }}>
              {subAccessoryTypes.map((optType, idx) => {
                const selected = this.state.selectedOptionTypes[optType.key] === true;
                return (
                  <ChipWrapper key={idx}>
                    <Chip
                      disabled={false}
                      title={optType.label}
                      value={optType.key}
                      selected={selected}
                      onClick={() => {
                        const stateCopy = {
                          ...this.state.selectedOptionTypes,
                        };
                        if (selected) {
                          delete stateCopy[optType.key];
                        } else {
                          stateCopy[optType.key] = true;
                        }
                        this.updateStateIfMounted({
                          selectedOptionTypes: stateCopy,
                        });
                      }}
                    ></Chip>
                  </ChipWrapper>
                );
              })}
            </div>
          </Scrollbars>
        </OptionTypesWrapper>
      </>
    );
  }

  renderQuantity = (subAcc) => {
    return (
      <QuantityEditor
        id={`${this.props.accessoryIdentification.identificationKey}-${subAcc.subAccessoryIdentification.identificationKey}-subaccessories-bom`}
        primaryColor={this.props.primaryColor}
        primaryTextColor={this.props.primaryTextColor}
        isSaving={this.props.isSaving}
        quantity={subAcc.quantity}
        canIncrease={subAcc.canIncrease}
        onIncrease={() => {
          this.props.onAddSubAccessories(this.props.deviceIdentification, this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(() => {
            this.props.raiseNotificationEvent('added', subAcc, 1);
            this.props.retrieveOptions();
          });
        }}
        canDecrease={subAcc.canDecrease}
        onDecrease={() => {
          if (subAcc.quantity === 1) {
            this.props.onRemoveSubAccessories(this.props.deviceIdentification, this.props.accessoryIdentification, subAcc.subAccessoryIdentification).then(() => {
              this.props.raiseNotificationEvent('removed', subAcc, 1);
              this.props.retrieveOptions();
            });
          } else {
            this.props.onDecreaseSubAccessories(this.props.deviceIdentification, this.props.accessoryIdentification, subAcc.subAccessoryIdentification, 1).then(() => {
              this.props.raiseNotificationEvent('removed', subAcc, 1);
              this.props.retrieveOptions();
            });
          }
        }}>
      </QuantityEditor>);
  }

  renderActionButtons = (subAcc) => {
    return (<EditAndDeleteWrapper>
      {subAcc.canRemove && <IconButton id={`${this.props.accessoryIdentification.identificationKey}-${subAcc.subAccessoryIdentification.identificationKey}-subaccessories-bom-remove`} icon="remove" size={40} padding={7} color={'#626469'} onClick={() => {
          this.props.onRemoveSubAccessories(this.props.deviceIdentification, this.props.accessoryIdentification, subAcc.subAccessoryIdentification).then(() => {
            this.props.raiseNotificationEvent('removed', subAcc, 1);
            this.props.retrieveOptions();
          });
      }} disabled={this.props.isSaving}>
      </IconButton>}
    </EditAndDeleteWrapper>);
  }

  renderSubAccessoryCategory = (subAcc) => {

    const addDisabled = this.props.isSaving || !subAcc.canAdd;
    const description = subAcc.getOptionDescription();

    return (
      <OptionWrapper mobileBreakpoint={this.props.mobileBreakpoint}>
        <OptionContent>
          <OptionImage src={subAcc.imageUrl}></OptionImage>
          <CategoryDescriptionAndActionsWrapper>
            <OptionCol>
              <OptionLinkWrapper>
                <LinkWrapper>
                  {this.props.renderProductLink(subAcc.id)}
                </LinkWrapper>
                {(subAcc.status === 'recommanded' || subAcc.status === 'mandatory') && <StatusTooltip fixed={true} getLabel={this.props.getLabel} status={subAcc.status}></StatusTooltip>}
              </OptionLinkWrapper>
              <DescriptionWrapper>
                <OptionDescription title={description}>{description}</OptionDescription>
              </DescriptionWrapper>
            </OptionCol>
            {this.props.option.quantity > 0 && <OptionRow>
              {this.renderActionButton(subAcc, addDisabled)}
            </OptionRow>}
          </CategoryDescriptionAndActionsWrapper>
        </OptionContent>
      </OptionWrapper>
    );
  }

  renderContent = (numberOfSubAccessories) => {
    let content = <></>;
    if (this.state.isOpen) {
      const subAccessoryTypes = this.extractSubAccessoryTypes();
      content = (
        <>
          {subAccessoryTypes.length > 0 && this.renderSubAccessoryTypes(subAccessoryTypes)}
          <OptionsContent mobileBreakpoint={this.props.mobileBreakpoint}>
            {Object.values(this.props.subAccessories).filter(subAcc => {
              let showSubAcc = true;
              if (subAcc.optionTypes && Object.keys(this.state.selectedOptionTypes).length > 0) {
                let atLeastOneSubAccFound = false;
                for (let i = 0; i < subAcc.optionTypes?.length && !atLeastOneSubAccFound; i++) {
                  if (this.state.selectedOptionTypes[subAcc.optionTypes[i].key]) {
                    atLeastOneSubAccFound = true;
                  }
                }
                showSubAcc = atLeastOneSubAccFound;
              }
              return showSubAcc;
            }).map((subAcc, idx) => {
              return (
                <Fragment key={idx}>{this.renderSubAccessoryCategory(subAcc)}</Fragment>
              );
            })}
          </OptionsContent>
        </>
      );
    } else if (numberOfSubAccessories > 0) {
      content = (
        <ContentWrapper>{this.renderSubAccessoriesBOM()}</ContentWrapper>
      );
    }

    return content;
  };

  render = () => {
    const numberOfSubAccessories = Object.values(this.props.subAccessories)
      .map((subAcc) => subAcc.quantity || 0)
      .reduce((sum, val) => sum + val, 0);

    return (
      <Container>
        <Header>
          <HeaderLabel>
            {this.props.getAndReplaceLabel(
              "options_screen.nb_sub_accessories_available",
              Object.keys(this.props.subAccessories).length,
              'nb'
            )}
          </HeaderLabel>
          {this.renderToggleButton(this.props.accessoryIdentification, numberOfSubAccessories, () => {
            this.setState({ isOpen: !this.state.isOpen });
          })}
        </Header>
        <Content>{this.renderContent(numberOfSubAccessories)}</Content>
      </Container>
    );
  };
}

export default SubAccessoriesManager;
